import React, { useContext, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { AuthContext } from '../../context/AuthContext'
import { handleOAuthError } from '../../utils/oauthHelpers'

export function Callback() {
  const location = useLocation()
  const navigate = useNavigate()
  const { sendMicrosoftCode } = useContext(AuthContext)
  const query = new URLSearchParams(location.search)

  useEffect(() => {
    const code = query.get('code')
    const error = query.get('error')
    const errorDescription = query.get('error_description')

    if (error) {
      // Handle OAuth error (e.g., user denied consent)
      handleOAuthError(error, errorDescription)

      // Redirect to signin page
      navigate('/signin', { replace: true })
      return
    }

    if (code) {
      sendMicrosoftCode(code)
    } else {
      // No code and no error - unexpected state, redirect to signin
      navigate('/signin', { replace: true })
    }
  }, [])

  return <></>
}
